export const InvalidEmail = 'Invalid email';
export const EmailValidationMessages = {
  success: 'Email is available',
  error: 'Email is not available',
};

export const UsernameRequired = 'Username is required';
export const UsernameValidationMessages = {
  success: 'Username is available',
  error: 'Username is not available',
};

export const ForgotPasswordEmailValidationMessages = {
  success: 'Email found',
  error: 'Email not found',
};
